
import { defineComponent } from "vue";

export default defineComponent({
  name: "FlexibleText",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    localValue: "",
  }),
  watch: {
    value: {
      handler(val) {
        this.$nextTick(() => {
          if (
            this.$refs.box instanceof HTMLDivElement &&
            this.$refs.resizer instanceof HTMLDivElement
          ) {
            this.$refs.box.style.maxWidth =
              this.$refs.resizer.offsetWidth + 1 + "px";
            this.$refs.box.style.minWidth =
              this.$refs.resizer.offsetWidth + 1 + "px";
          }
          this.localValue = val;
        });
      },
      immediate: true,
    },
  },
});
